import logo from './logo.svg';
import './App.css';
import Bmi from './components/Bmi'
// import Periodtracker from './components/Periodtracker'
import Nav from './components/Nav'
function App() {
  return (
    <div>
      <Nav/>
      {/* <Card_R/> */}
      {/* <Bmi/> */}
    </div>
  );
}

export default App;
